export default __webpack_public_path__ + "static/media/avatar_154.736ff24f.png";